import { render, staticRenderFns } from "./QueryPolicyCargoRisk.vue?vue&type=template&id=42678272&"
import script from "./QueryPolicyCargoRisk.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyCargoRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports